// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MoneyCollectOutlinedSvg from "@ant-design/icons-svg/es/asn/MoneyCollectOutlined";
import AntdIcon from '../components/AntdIcon';

var MoneyCollectOutlined = function MoneyCollectOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectOutlinedSvg
  }));
};

MoneyCollectOutlined.displayName = 'MoneyCollectOutlined';
export default React.forwardRef(MoneyCollectOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MoneyCollectOutlined.js
// module id = 1509
// module chunks = 0